<template>
  <b-container fluid class="complex-filter-frame">
    <b-row>
      <b-col sm="5" class="text-left">
        <div class="complex-header">Összetett Feltételek</div>
      </b-col>
      <b-col sm="4">
        <b-form-group label-for="filter-input">
          <b-form-input
            @update="onNameChanged"
            id="filter-name-input"
            :value="name"
            type="search"
            placeholder="Keresés"
            class="search-box"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-button @click="goToCreate" variant="primary">Új összetett feltétel</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-table :items="list" per-page="0" :fields="fields" :filter="name">
        <template #cell(name)="row"
          ><b-link :to="{ path: '/competitions/complex-filter/edit', query: { id: row.item._id } }">
            {{ row.item.name }}</b-link
          >
        </template>
      </b-table>
    </b-row>
  </b-container>
</template>
<script>
import { listComplexFilters } from '../../api/complexFilter'
export default {
  name: 'ComplexFilterList',
  data: function() {
    return {
      list: [],
      fields: [
        {
          key: 'name',
          label: 'Név'
        },
        {
          key: 'createdBy.fullName',
          label: 'Létrehozta'
        },
        {
          key: 'createdDate',
          label: 'Létrehozva',
          formatter: date => this.formatDate(date)
        },
        {
          key: 'modifiedDate',
          label: 'Utolsó módosítás',
          formatter: date => this.formatDate(date)
        }
      ],
      name: ''
    }
  },
  created: async function() {
    const complexFilters = await listComplexFilters()
    this.list = complexFilters
  },
  methods: {
    formatDate: function(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    },
    goToCreate: function() {
      this.$router.push('complex-filter/create')
    },
    onNameChanged: function(value) {
      this.name = value
    }
  }
}
</script>
<style scoped>
.complex-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  color: black;
}
.complex-filter-frame {
  margin-left: 15px;
  margin-right: 15px;
}
</style>
